import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import api from "../../api/client";
import StatusBadge from "../shared/StatusBadge";
import { useAuth } from "../../context/AuthContext";

const formatCAD = (n) =>
    new Intl.NumberFormat("en-CA", {
        style: "currency",
        currency: "CAD",
    }).format(n ?? 0);

const QuotesList = () => {
    const { t } = useTranslation();
    const { user } = useAuth();
    const isAdmin = user?.role === "admin";
    const [quotes, setQuotes] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.quotes()
            .then((r) => setQuotes(r.quotes?.data || []))
            .finally(() => setLoading(false));
    }, []);

    return (
        <div>
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 20,
                }}
            >
                <div className="section-header" style={{ marginBottom: 0 }}>
                    <h2>{t("quote.title")}</h2>
                </div>
                {isAdmin && (
                    <Link
                        to="/admin/quotes/new"
                        className="btn btn--primary btn--sm"
                    >
                        {t("quote.new")}
                    </Link>
                )}
            </div>

            {loading ? (
                <p style={{ color: "var(--color-text-muted)" }}>
                    {t("common.loading")}
                </p>
            ) : (
                <div
                    className="card"
                    style={{ padding: 0, overflow: "hidden" }}
                >
                    <table className="dash-table">
                        <thead>
                            <tr>
                                <th>{t("quote.quoteTitle")}</th>
                                {isAdmin && <th>{t("quote.client")}</th>}
                                <th>{t("quote.status")}</th>
                                <th className="dash-table__right">
                                    {t("quote.total")}
                                </th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {quotes.length === 0 && (
                                <tr>
                                    <td
                                        colSpan={5}
                                        className="dash-table__empty"
                                    >
                                        {t("quote.noQuotes")}
                                    </td>
                                </tr>
                            )}
                            {quotes.map((q) => (
                                <tr key={q.id}>
                                    <td>{q.title}</td>
                                    {isAdmin && (
                                        <td className="dash-table__muted">
                                            {q.client?.name}
                                        </td>
                                    )}
                                    <td>
                                        <StatusBadge status={q.status} />
                                    </td>
                                    <td className="dash-table__right dash-table__mono">
                                        {formatCAD(q.total)}
                                    </td>
                                    <td>
                                        <Link
                                            to={
                                                isAdmin
                                                    ? `/admin/quotes/${q.id}`
                                                    : `/dashboard/quotes/${q.id}`
                                            }
                                            className="btn btn--ghost btn--sm"
                                        >
                                            {isAdmin
                                                ? t("common.edit")
                                                : t("common.view")}
                                        </Link>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default QuotesList;
